import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-38edd136")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "static-table",
    style: { width: _ctx.totalWidth + 'px' }
  }, [
    _createVNode("table", {
      class: {
        'theme': _ctx.theme,
        'row-header': _ctx.theme?.rowHeader,
        'row-footer': _ctx.theme?.rowFooter,
        'col-header': _ctx.theme?.colHeader,
        'col-footer': _ctx.theme?.colFooter,
      },
      style: `--themeColor: ${_ctx.theme?.color}; --subThemeColor1: ${_ctx.subThemeColor[0]}; --subThemeColor2: ${_ctx.subThemeColor[1]}`
    }, [
      _createVNode("colgroup", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colSizeList, (width, index) => {
          return (_openBlock(), _createBlock("col", {
            span: "1",
            key: index,
            width: width
          }, null, 8, ["width"]))
        }), 128))
      ]),
      _createVNode("tbody", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (rowCells, rowIndex) => {
          return (_openBlock(), _createBlock("tr", { key: rowIndex }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(rowCells, (cell, colIndex) => {
              return _withDirectives((_openBlock(), _createBlock("td", {
                class: "cell",
                style: {
              borderStyle: _ctx.outline.style,
              borderColor: _ctx.outline.color,
              borderWidth: _ctx.outline.width + 'px',
              ..._ctx.getTextStyle(cell.style),
            },
                key: cell.id,
                rowspan: cell.rowspan,
                colspan: cell.colspan
              }, [
                _createVNode("div", {
                  class: "cell-text",
                  innerHTML: cell.text
                }, null, 8, ["innerHTML"])
              ], 12, ["rowspan", "colspan"])), [
                [_vShow, !_ctx.hideCells.includes(`${rowIndex}_${colIndex}`)]
              ])
            }), 128))
          ]))
        }), 128))
      ])
    ], 6)
  ], 4))
})